export const chunk = (collection, size) => {
    const chunkedCollection = [];

    for (let offset = 0; offset < collection.length; offset += size) {
        chunkedCollection.push(collection.slice(offset, offset + size));
    }

    return chunkedCollection;
};
